// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"de3fd2bc","453":"e62fbdee","672":"c6cb1022"}[chunkId] + ".chunk.js";
};